<!--begin::Main-->
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading"> <svg width="32" height="29" viewBox="0 0 32 29" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_82_1744)">
                                    <path
                                        d="M21.795 7.11531C19.8257 7.11531 18.2199 5.51738 18.2199 3.55766C18.2199 1.59793 19.8257 0 21.795 0C23.7643 0 25.3701 1.59793 25.3701 3.55766C25.3701 5.51738 23.7643 7.11531 21.795 7.11531ZM16.3112 4.58274C16.3112 2.05017 14.2509 0.0301492 11.7363 0.0301492C9.19127 0.0301492 7.16135 2.08032 7.16135 4.58274C7.16135 7.11531 9.22157 9.13533 11.7363 9.13533C14.2812 9.13533 16.3112 7.08516 16.3112 4.58274ZM27.0667 15.9491C27.5212 15.9491 27.8848 15.5572 27.8242 15.105C27.3394 11.6076 25.8245 8.1404 21.795 8.1404C19.5227 8.1404 18.0381 9.25593 17.0989 10.8539C17.7654 11.4267 18.3714 12.09 18.8561 12.904C19.4015 13.7784 19.8863 14.8035 20.2498 15.9793H27.0667V15.9491ZM4.01041 19.2053C3.91952 19.8686 4.43457 20.5017 5.13142 20.5017H18.3411C19.0379 20.5017 19.553 19.8987 19.4621 19.2053C18.7956 14.8035 16.8565 10.4619 11.7363 10.4619C6.61599 10.4619 4.67695 14.8035 4.01041 19.2053Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_82_1744" x="0" y="0" width="31.8308" height="28.5017"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_82_1744" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_82_1744"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>
                            Appels d'offres
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/acceuil" class="text-muted ">Accueil</a>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted"> <a class="text-muted "
                                routerLink="/acceuil/appel-offre/list-appel-offre"> Appels d'offres</a></li>
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">Voir Barème</li>
                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
                <!--end::Page title-->
                <!--begin::Actions-->

                <!--end::Actions-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class="card pt-15 pb-15">

                    <div class="container" [formGroup]="BaremeForm">
                        <div class="head">
                            <!-- <h4>Choisissez les facteurs et les coefficients</h4> -->
                        </div>
                        <div class="info p-10">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="skill mb-5" formArrayName="skill_score">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <label class="form-check-label" for="Comptétence">
                                                Comptétence
                                            </label>
                                            <!-- <div (click)="addSkills()">
                                                <img src="/assets/media/addIcon.png" alt="addIcon" width="20"
                                                    class="addIcon">
                                            </div> -->
                                        </div>
                                        <div *ngFor="let skills of skillsControls; let i = index">
                                            <div class="row" [formGroupName]="i">
                                                <div class="col-lg-8">
                                                    <div class="input">
                                                        <ng-select [items]="skillsList" bindLabel="name_FR"
                                                            class="form-select  mb-3" bindValue="id"
                                                            formControlName="skill_job_id" id="competences"
                                                            placeholder="compétences"
                                                            [notFoundText]="'Aucun élément trouvé'" [readonly]="true">
                                                        </ng-select>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="input">
                                                        <input type="number" name="number" id="number"
                                                            formControlName="coef" class="form-control mb-3"
                                                            placeholder="Coef" [readonly]="true">
                                                        <!-- <div (click)="removeSkills(i)"><img
                                                                src="/assets/media/deleteIcon.png" class="deleteIcon"
                                                                alt="deleteIcon" width="20"></div> -->

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="skill mb-5" formArrayName="experience_score">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <label class="form-check-label" for="Années">
                                                Années expériences
                                            </label>

                                        </div>
                                        <div *ngFor="let experiences of experiencesControls; let i = index">
                                            <div class="row" [formGroupName]="i">
                                                <div class="col-lg-8">
                                                    <div class="input">
                                                        <input type="number" id="year_experience"
                                                            class="form-control mb-3" formControlName="year_experience"
                                                            placeholder="Années expériences" style="width: 100%;" [readonly]="true">
                                                    </div>
                                                </div>

                                                <div class="col-lg-4">
                                                    <div class="input">
                                                        <input type="number" id="coef" formControlName="coef"
                                                            class="form-control mb-3" placeholder="Coef" [readonly]="true">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="skill mb-5">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <label class="form-check-label" for="Score">
                                                Score
                                            </label>
                                            <div>

                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-8">
                                                <div class="input">
                                                    <input type="number" id="scoreQCM" class="form-control"
                                                        placeholder="100%" style="width: 100%;" disabled>
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <div class="input">
                                                    <input type="number" id="test_qcm_score"
                                                        formControlName="test_qcm_score" class="form-control mb-3"
                                                        placeholder="Coef" [readonly]="true">
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="skill mb-5" formArrayName="language_score">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <label class="form-check-label" for="Langue">
                                                Langue
                                            </label>
                                            <!-- <div (click)="addLangues()">
                                                <img src="/assets/media/addIcon.png" alt="addIcon" width="20"
                                                    class="addIcon">
                                            </div> -->
                                        </div>
                                        <div *ngFor="let langue of langueControls; let i = index">
                                            <div class="row" [formGroupName]="i">
                                                <div class="col-lg-8">
                                                    <div class="input">
                                                        <ng-select [items]="languages" bindLabel="name"
                                                            class="form-select  mb-3" bindValue="name"
                                                            formControlName="language" id="language"
                                                            placeholder="Langue"
                                                            [notFoundText]="'Aucun élément trouvé'" [readonly]="true">
                                                        </ng-select>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="input">
                                                        <input type="number" id="coef" formControlName="coef"
                                                            class="form-control mb-3" placeholder="Coef" [readonly]="true">
                                                        <!-- <div (click)="removeLangue(i)"><img
                                                                src="/assets/media/deleteIcon.png" alt="deleteIcon"
                                                                width="20" class="deleteIcon"></div> -->

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-lg-6">
                                    <div class="skill mb-5" formArrayName="availibility_score">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <label class="form-check-label" for="flexCheckDefault">
                                                Disponibilité
                                            </label>
                                            <!-- <div (click)="addAvailability()">
                                                <img src="/assets/media/addIcon.png" alt="addIcon" width="20"
                                                    class="addIcon">
                                            </div> -->
                                        </div>
                                        <div *ngFor="let availibility of availibility_scoreControls; let i = index">
                                            <div class="row" [formGroupName]="i">
                                                <div class="col-lg-8">

                                                    <div class="input">
                                                        <ng-select [items]="disponibilite" class="form-select  mb-3"
                                                            id="disponibilite" bindLabel="name" bindValue="value"
                                                            [placeholder]="'Disponibilité'" autoComplete
                                                            formControlName="availability"
                                                            [notFoundText]="'Aucun élément trouvé'" [readonly]="true">
                                                        </ng-select>
                                                    </div>
                                                </div>

                                                <div class="col-lg-4">
                                                    <div class="input">
                                                        <input type="number" id="coef" formControlName="coef"
                                                            class="form-control mb-3" placeholder="Coef" [readonly]="true">
                                                        <!-- <div (click)="removeAvailability(i)"><img
                                                                src="/assets/media/deleteIcon.png" alt="deleteIcon"
                                                                width="20" class="deleteIcon"></div> -->

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container">
                            <div class="compare-btn">
                                <!-- routerLink="/acceuil/candidats/result-compare"  -->
                                <!-- <a (click)="addBareme()" class="compare">Confirmer</a> -->
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>


<div class="modal fade" tabindex="-1" id="critere">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">Ajouter critère</h3>

                <!--begin::Close-->
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                    aria-label="Close">
                    <i class="ki-duotone ki-cross fs-1"><span class="path1"></span><span class="path2"></span></i>
                </div>
                <!--end::Close-->
            </div>

            <div class="modal-body">
                <form id="kt_customers_export_form" class="form" action="#">
                    <!--begin::Input group-->
                    <div class="fv-row mb-5">
                        <!--begin::Label-->
                        <div class="mb-5">
                            <label for="question" class="required form-label">Nom critère</label>
                            <input type="text" class="form-control mb-3" placeholder="Nom du critère" />
                        </div>
                        <div class="mb-5">
                            <label for="score" class="required form-label">score</label>
                            <input type="text" class="form-control mb-3" placeholder="score" />
                        </div>
                    </div>
                </form>

            </div>

            <div class="modal-footer">
                <button type="button" class="confirm">Confirmer</button>
            </div>
        </div>
    </div>
</div>